module.exports = __webpack_public_path__ + "img/bg-zpxx.e122ac35.png";